import React from 'react';
import { Redirect } from 'react-router-dom';
import configData from '../../config/config.json';
import Header from "../../features/Layout/Header"
import Footer from "../../features/Layout/Footer"
import Deck from "./Deck"
import MonthsDeck from "./MonthsDeck"
import HorizontalDeck from "./HorizontalDeck"
//import Search from "../../features/FiltersManager/Search"
import FiltersManager from "../../features/FiltersManager"
import Heading from "../../features/Heading"
import './index.css'
import { validateYupSchema } from 'formik';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import MainNavigationBar from "../../features/Layout/MainNavigationBar";
import { animateScroll as scroll, scroller } from 'react-scroll' ;
import Spinner from "../../features/Spinner/spinner";
import { withTranslation } from 'react-i18next';
import { addLangParam } from '../../utils/apiHelpers';


const API_ENDPOINT = configData.API_ENDPOINT;
const API_QUERY = "?";//"get/?lang=he";
let API_PREDEFINED_QUERY = "";
let API_OBJECT = "/search/packages/";

class Destination extends React.Component {

  
  constructor(props) {
    
    super(props);

    // Load query string parameters or set default values
    let stars = new URLSearchParams(props.location.search).get("stars")?new URLSearchParams(props.location.search).get("stars").split(','):[];
    let meals = new URLSearchParams(props.location.search).get("meals")?new URLSearchParams(props.location.search).get("meals").split(','):[];
    let holidays = new URLSearchParams(props.location.search).get("holidays")?new URLSearchParams(props.location.search).get("holidays").split(','):[];
    let dates_type = new URLSearchParams(props.location.search).get("dates_type")?new URLSearchParams(props.location.search).get("dates_type"):'';
    let nights = new URLSearchParams(props.location.search).get("nights")?new URLSearchParams(props.location.search).get("nights").split(','):[];
    let from_date = new URLSearchParams(props.location.search).get("from_date")?new URLSearchParams(props.location.search).get("from_date"):'';
    let to_date = new URLSearchParams(props.location.search).get("to_date")?new URLSearchParams(props.location.search).get("to_date"):'';
    this.months = new URLSearchParams(props.location.search).get("months")?(new URLSearchParams(props.location.search).get("months")).split(','):[];
    let month = new URLSearchParams(props.location.search).get("month")?(new URLSearchParams(props.location.search).get("month")):'';
    //let sortby = new URLSearchParams(props.location.search).get("sortby")?new URLSearchParams(props.location.search).get("sortby"):'price-asc';
    let destinations = (new URLSearchParams(props.location.search).get("destinations")&&new URLSearchParams(props.location.search).get("destinations")!=='')===true?new URLSearchParams(props.location.search).get("destinations").split(','):[];
    if (destinations.length===0) 
      destinations = (new URLSearchParams(props.location.search).get("destination")&&new URLSearchParams(props.location.search).get("destination")!=='')===true?new URLSearchParams(props.location.search).get("destination").split(','):[];
    let adults = new URLSearchParams(props.location.search).get("adults")?new URLSearchParams(props.location.search).get("adults"):2;
    let teens = new URLSearchParams(props.location.search).get("teens")?new URLSearchParams(props.location.search).get("teens"):0;
    let children = new URLSearchParams(props.location.search).get("children")?new URLSearchParams(props.location.search).get("children"):0;
    let infants = new URLSearchParams(props.location.search).get("infants")?new URLSearchParams(props.location.search).get("infants"):0;
    let dow = new URLSearchParams(props.location.search).get("dow")?new URLSearchParams(props.location.search).get("dow"):'';
    let waterpark = new URLSearchParams(props.location.search).get("waterpark") || new URLSearchParams(props.location.search).get("waterparks")?true:false;
    let luxury = new URLSearchParams(props.location.search).get("luxury") || new URLSearchParams(props.location.search).get("luxury")?true:false;
    let casino = new URLSearchParams(props.location.search).get("casino") || new URLSearchParams(props.location.search).get("casino")?true:false;
    let near_chabad = new URLSearchParams(props.location.search).get("chabad") || new URLSearchParams(props.location.search).get("chabad")?true:false;
    let spa = new URLSearchParams(props.location.search).get("spa") || new URLSearchParams(props.location.search).get("spa")?true:false;
    let airlines = new URLSearchParams(props.location.search).get("airlines")?(new URLSearchParams(props.location.search).get("airlines")).split(','):[];
    let page = new URLSearchParams(props.location.search).get("page")?(new URLSearchParams(props.location.search).get("page")):'';


    this.state = {
      'shouldRedirect': false,
      'monthsContent': [],
      //'daysContent': [],
      'destinations': [],
      'carousel_items': [],
      'isLoading'   : true,
      'error'       : null,
      'show_destinations_popup': false,
      'cheapestPrice': null,
      'filters' : {
        'window': {
          'visible': false,
          'active_tab': 'search',
          'refresh_count': 0,
          'step': '0'
        },
        'origin': {
          'iata': {
            'TLV': true,
            'ETM': false
          },
        },
        //'from_airport'  : 'TLV',
        'stars'         : stars,
        'meals'         : meals,
        'holidays'      : holidays,
        'dates_type'    : dates_type,
        'nights'        : nights,
        'from_date'     : from_date,
        'to_date'       : to_date,
        'limit'         : 10,
        'destination_name': this.city,
        'destinations'  : destinations,
        //'destination'  : this.props?.destination,
        //'sortby'        : sortby,
        'months'        : this.months,
        'month'         : month,
        'page'          : page,
        'adults'        : adults,
        'teens'        : teens,
        'children'      : children,
        'infants'       : infants,
        'dow'           : dow,
        'airlines'      : airlines,
        'highlights'    : {
          'waterpark'     : waterpark,
          'luxury'        : luxury,
          'casino'        : casino,
          'near_chabad'        : near_chabad,
          'spa'        : spa,
          'loading_deals' : false
        },
        'selectedMonth': this.months && this.months.length > 0 ? {year: this.months[0].split('-')[0], month: this.months[0].split('-')[1]} : null,
        'cheapestMonth': this.months && this.months.length > 0 ? {year: this.months[0].split('-')[0], month: this.months[0].split('-')[1]} : null
      },
      cities: [],
      heading_key: 0
    }
    
    // binding
    this.getFilters = this.getFilters.bind(this); 
    this.fetchDestinations = this.fetchDestinations.bind(this);
    //this.handleClose = this.handleClose.bind(this); 
    this.openSearch = this.openSearch.bind(this);
    this.showDestinationSelectionPopup = this.showDestinationSelectionPopup.bind(this);
    this.handleCloseSearchWindow = this.handleCloseSearchWindow.bind(this);
    this.closeSearchWindow = this.closeSearchWindow.bind(this);
    this.getDestinationDetails = this.getDestinationDetails.bind(this);
    this.showSearchWindow = this.showSearchWindow.bind(this);
    this.gotoStep = this.gotoStep.bind(this); 
    this.handleSelectMonth = this.handleSelectMonth.bind(this);

    const base = this.props.history.location.pathname.split('/');
    this.city = base[1];
    this.month_name = base[2];
    this.month = month.split(',')[0].split('-')[0];
    this.year  = month.split(',')[0].split('-')[0];

    // load destination
  }

  componentDidMount() {
    //console.log('componentDidMount')
    window.addEventListener('scroll', this.handleScroll);

    this.refetchData()

    this.backListener = this.props.history.listen((action => {
      this.LoadQueryStringAndCreateState(action.search, true)
    }));

    // Open pax change window when page loads if querysting param search=pax
    if (new URLSearchParams(this.props.location.search).get("search")=='pax')
        this.gotoStep(null, 0, true);
 
  }


  componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    //nav = React.createRef();

    handleScroll = () => {
        
        if (this.props.hide) return

        const lastScrollY = window.scrollY;
        if (lastScrollY > 1) {
            document.getElementById("headerNav").classList.add("fixed");
        }
        else {
            document.getElementById("headerNav").classList.remove("fixed");
        }

        if (lastScrollY > 300) {
            document.getElementById("FiltersWrapper").classList.add("fixed");
        }
        else {
            document.getElementById("FiltersWrapper").classList.remove("fixed");
        }
    };

  setDescription = desc => {
    const el = document.querySelector("meta[name='description']");
    el.setAttribute('content',desc)
  }

  UNSAFE_componentWillMount() {

    this.GenerateTitle();
    const { t } = this.props;
    const monthPart = this.month_name ? ` ${t('destination.meta.monthPrefix')}${this.month_name}` : '';
    this.setDescription(t('destination.meta.descriptionTemplate', {
      city: this.city,
      monthPart: monthPart
    }));
  }
  
  GenerateTitle(price=null) {
    const { t } = this.props;

    let monthYearPart = '';
    if (this.month_name && this.month_name !== '') {
      monthYearPart = t('destination.meta.titleMonthPart', {
        month: this.month_name,
        year: this.year
      });
    }

    let pricePart = '';
    if (price) {
      pricePart = ` ${t('destination.meta.startingFrom', { price })}`;
    }

    const title = t('destination.meta.titleTemplate', {
      city: this.city || '',
      monthYearPart,
      pricePart
    });

    document.title = title;
  }
  
  async LoadQueryStringAndCreateState(url, update=false) {
    
    const props = this.props;
    
    // Load query string parameters or set default values
    let stars = new URLSearchParams(props.location.search).get("stars")?new URLSearchParams(props.location.search).get("stars").split(','):[];
    let meals = new URLSearchParams(props.location.search).get("meals")?new URLSearchParams(props.location.search).get("meals").split(','):[];
    let holidays = new URLSearchParams(props.location.search).get("holidays")?new URLSearchParams(props.location.search).get("holidays").split(','):[];
    let dates_type = new URLSearchParams(props.location.search).get("dates_type")?new URLSearchParams(props.location.search).get("dates_type"):'';
    let nights = new URLSearchParams(props.location.search).get("nights")?new URLSearchParams(props.location.search).get("nights").split(','):[];
    let from_date = new URLSearchParams(props.location.search).get("from_date")?new URLSearchParams(props.location.search).get("from_date"):'';
    let to_date = new URLSearchParams(props.location.search).get("to_date")?new URLSearchParams(props.location.search).get("to_date"):'';
    let months = new URLSearchParams(props.location.search).get("months")?(new URLSearchParams(props.location.search).get("months")).split(','):[];
    let month = new URLSearchParams(props.location.search).get("month")?(new URLSearchParams(props.location.search).get("month")).split(','):'';
    //let sortby = new URLSearchParams(props.location.search).get("sortby")?new URLSearchParams(props.location.search).get("sortby"):'price-asc';
    let destinations = (new URLSearchParams(props.location.search).get("destinations")&&new URLSearchParams(props.location.search).get("destinations")!=='')===true?new URLSearchParams(props.location.search).get("destinations").split(',')[0]:[];
      if (destinations.length===0)
        destinations = (new URLSearchParams(props.location.search).get("destination")&&new URLSearchParams(props.location.search).get("destination")!=='')===true?new URLSearchParams(props.location.search).get("destination").split(',')[0]:[];
    let adults = new URLSearchParams(props.location.search).get("adults")?new URLSearchParams(props.location.search).get("adults"):2;
    let teens = new URLSearchParams(props.location.search).get("teens")?new URLSearchParams(props.location.search).get("teens"):0;
    let children = new URLSearchParams(props.location.search).get("children")?new URLSearchParams(props.location.search).get("children"):0;
    let infants = new URLSearchParams(props.location.search).get("infants")?new URLSearchParams(props.location.search).get("infants"):0;
    let dow = new URLSearchParams(props.location.search).get("dow")?new URLSearchParams(props.location.search).get("dow"):'';
    let waterpark = new URLSearchParams(props.location.search).get("waterpark") || new URLSearchParams(props.location.search).get("waterparks")?true:false;
    let luxury = new URLSearchParams(props.location.search).get("luxury") || new URLSearchParams(props.location.search).get("luxury")?true:false;
    let casino = new URLSearchParams(props.location.search).get("casino") || new URLSearchParams(props.location.search).get("casino")?true:false;
    let near_chabad = new URLSearchParams(props.location.search).get("chabad") || new URLSearchParams(props.location.search).get("chabad")?true:false;
    let spa = new URLSearchParams(props.location.search).get("spa") || new URLSearchParams(props.location.search).get("spa")?true:false;
    let airlines = new URLSearchParams(props.location.search).get("airlines")?(new URLSearchParams(props.location.search).get("airlines")).split(','):[];
    let page = new URLSearchParams(props.location.search).get("page")?(new URLSearchParams(props.location.search).get("page")).split(','):'';


    const current_location = props.location.search;


    this.state = {
      //'daysContent': [],
      'monthsContent': [],
      'destinations': [],
      'carousel_items': [],
      'isLoading'   : true,
      'error'       : null,
      'show_destinations_popup': false,
      'filters' : {
        'window': {
          'visible': false,
          'active_tab': 'search',
          'refresh_count': 0
        },
        'origin': {
          'iata': {
            'TLV': true,
            'ETM': false
          },
        },
        //'from_airport'  : 'TLV',
        'stars'         : stars,
        'meals'         : meals,
        'holidays'      : holidays,
        'dates_type'    : dates_type,
        'nights'        : nights,

        'from_date'     : from_date,
        'to_date'       : to_date,
        'limit'         : 10,
        'destination_name': this.city,
        'destinations'  : destinations,
        //'sortby'        : sortby,
        'months'        : months,
        'month'         : month,
        'page'          : page,
        'adults'        : adults,
        'teens'        : teens,
        'children'      : children,
        'infants'       : infants,
        'dow'           : dow,
        'waterpark'     : waterpark,
        'luxury'        : luxury,
        'casino'        : casino,
        'near_chabad'   : near_chabad,
        'spa'           : spa,
        'airlines'           : airlines,
        'loading_deals' : false
      },
      cities: [],
      heading_key: 0
    }
  
  }

  objectToQueryString(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }

  refetchData(updateURL=false) {
      console.log('Refetch2')
      

      this.query_options = new Map();
      this.query_options.set('stars',this.state.filters.stars);
      this.query_options.set('meals',this.state.filters.meals);
      this.query_options.set('holidays',this.state.filters.holidays);
      this.query_options.set('dates_type',this.state.filters.dates_type);
      this.query_options.set('nights',this.state.filters.nights);
      //this.query_options.set('from_airport',this.state.filters.from_airport);
      //this.query_options.set('months',this.state.filters.months);
      this.query_options.set('month',this.state.filters.month);
      //this.query_options.set('sortby',this.state.filters.sortby);
      this.query_options.set('from_date',this.state.filters.from_date);
      this.query_options.set('to_date',this.state.filters.to_date);
      this.query_options.set('adults',this.state.filters.adults);
      this.query_options.set('teens',this.state.filters.teens);
      this.query_options.set('children',this.state.filters.children);
      this.query_options.set('infants',this.state.filters.infants);
      this.query_options.set('dow',this.state.filters?.dow);
      this.query_options.set('waterpark',this.state.filters?.highlights?.waterpark);
      this.query_options.set('luxury',this.state.filters?.highlights?.luxury);
      this.query_options.set('casino',this.state.filters?.highlights?.casino);
      this.query_options.set('chabad',this.state.filters?.highlights?.near_chabad);
      this.query_options.set('spa',this.state.filters?.highlights?.spa);
      this.query_options.set('airlines',this.state.filters.airlines);
      this.query_options.set('destinations',this.state.filters?.destinations);
      this.query_options.set('page',this.state.filters.page);
      this.query_options.set('limit', 1); // for some reason when I set this it shows 3 results per month :)


      this.query_options.set('source', 'destination'); 
      if (this.state.filters.month) 
        this.query_options.set('source_sub', 'destination_month');
        

      if (this.state.filters.from_date) 
            this.query_options.set('source_sub', 'destination_dates');
    
      this.query_options.set('destination_name', this.props.location.pathname.split('/')[1]);
      this.query_options.set('month_name', this.props.location.pathname.split('/')[2]);

  
      let querystring_array = [];

      // Remove empty keys
      // Sort values (if array)
      this.query_options.forEach((value,key) => {
        if (value && value!='') {
            if (Array.isArray(value))
              value = value.sort();

            querystring_array.push(`${key}=${value}`)  
        }
      });

      // Sort result array by keys & rebuild querystring
      let querystring=querystring_array.sort((a,b)=>a-b).join('&');
      const baseUrl = API_ENDPOINT + API_OBJECT + API_QUERY + querystring + API_PREDEFINED_QUERY
      const url = addLangParam(baseUrl);

      // Check for invalid destination request:
      // - If source is 'destination' (destination page template)
      // - AND destinations parameter is empty/undefined/has no values
      // - Then this is an invalid request -> redirect to homepage
      const sourceParam = this.query_options.get('source');
      const destinationsParam = this.query_options.get('destinations');
      const hasValidDestinations = destinationsParam &&
                                   Array.isArray(destinationsParam) &&
                                   destinationsParam.length > 0;

      if (sourceParam === 'destination' && !hasValidDestinations) {
        console.log('Invalid destination request detected - redirecting to homepage');
        console.log('Source:', sourceParam, 'Destinations:', destinationsParam);
        this.setState(prevState => ({
          ...prevState,
          'shouldRedirect': true,
          'isLoading': false
        }));
        return; // Stop execution, don't make the API call
      }

      if (updateURL) {
        // Remove PAGE parameter from querystring
        //querystring = querystring.split(',').filter(item=>item.indexOf('page')!==false);1
        if (!(this.state?.filters?.page > 1))
          this.props.history.push(window.location.pathname + API_QUERY + querystring + API_PREDEFINED_QUERY)
      }

      return (
        fetch(url)
        .then(response => {
          if (response.ok) {
            return response.json()
          } else {
            throw new Error(this.props.t('destination.messages.error'));
          }
        })
        .then(data => {

          if (!data || !data?.destinations || !(data?.destinations.length>0)) {

            console.log('No deal')
            console.log(this.state)

            if (this.state?.filters?.page>1) {
            
              this.setState(prevState=>({
                ...prevState,
                filters: {
                  ...prevState.filters,
                  loading_deals: false,
                  no_more_deals: true
                }
              }))
            } else  {
              console.log('popuplating destination')
              this.setState(prevState=>({
                ...prevState,
                'isLoading': false,
                destinations: [{
                  deals: []
                }] 
              }))
            }

            return
          }

          let deals = data.destinations[0].deals;
          let pax = data.destinations[0].pax

          if (this.state?.filters?.page>1) {
            deals = this.state?.destinations[0].deals.concat(data.destinations[0].deals);
          }
          
          
           // Update cheapest deal price in the title
           try {
                const totalPrice = deals[0].price;
                const paxCount = pax.adults + pax.children + pax.infants;

                this.cheapestPrice = Math.ceil(totalPrice/paxCount);
                
                if (this.cheapestPrice > 0)
                    this.GenerateTitle(this.cheapestPrice);
            } catch(e) {}

          if (!this.state.selectedMonth && data.months && data.months.length > 0) {
            //console.log(`Default Month: ${data.months[0].id+1}`)
            
           this.setState(prevState=>({
              ...prevState,
              'selectedMonth': {
                    year: data.months[0].year,
                    month: data.months[0].id+1
                },
               'cheapestMonth': {
                    year: data.months[0].year,
                    month: data.months[0].id+1
                },
                
            }));
            // rerender
            //this.forceUpdate();
          }
            
          this.setState(prevState=>({
              ...prevState,
              //'destinations': this.state?.destinations,
              'monthsContent': data.months,
              //'daysContent': data?.days,
              'destinations': [{
                deals: deals
              }],
              'isLoading': false,
              'cheapestPrice': this.cheapestPrice,
              filters: {
                ...prevState.filters,
                loading_deals: false
              }
            }),()=>{
                const city_name = data?.destinations[0]?.destination?.city_name;
                const base = this.props.history.location.pathname.split('/');
                //this.city = base[1];
                let month = new URLSearchParams(this.props.location.search).get("month")?(new URLSearchParams(this.props.location.search).get("month")):'';
                const month_name = base[2];
                const year  = month.split(',')[0].split('-')[0];

                const { t } = this.props;
                const monthYearPart = (month_name && year) ? `${t('destination.meta.monthPrefix')}${month_name} ${year} ` : '';
                const pricePart = this.state?.cheapestPrice ? t('destination.meta.startingFromWithPrice', { price: this.state?.cheapestPrice }) : '';

                const metaDesc = t('destination.meta.descriptionDetailTemplate', {
                  city: city_name,
                  monthYearPart,
                  pricePart
                });
            }
         )
        })
        .catch(error => {
          
          console.log('ERROR')
          console.log(error)
          this.setState(prevState=>({
            ...prevState,
            error, 
            'isLoading': false,
            destinations:[{
              deals: []
            }]
        }))
      }
        )
      )
  }
 
  getDestinationDetails(data) {
    //console.log('getDestinationDetails')
    //console.log(data)
    this.setState(prevState=>({
        ...prevState,
        //'destination_sid': destination.sid,
        //'destination': destination
        filters: {
          ...prevState.filters,
          destination: data,
          //r: Math.random()
        }
      })
    )
  }

  /**
   * 
   * @param {*} step 
   * @param {*} next_step_close 
   */
  showSearchWindow(step='0', next_step_close=false) {
    console.log('Show search wizard ')

    this.setState((prevState) => (
      {
          ...prevState,
          filters: {
              ...prevState.filters,  
              'window': {
                  ...prevState.filters.windows,
                  'visible': true,
                  'active_tab': 'search',
                  'step': step,
                  'next_step_close': next_step_close
              }
          }            
      }
  ));
}

closeSearchWindow() {
  this.setState((prevState) => (
    {
        ...prevState,
        filters: {
            ...prevState.filters,  
            'window': {
                ...prevState.filters.windows,
                'visible': false,
            }
        }            
    }
));
}

 
  /**
   * 
   * @param {*} step 
   * @param {*} next_step_close 
   */
  showSearchWindow(step='0', next_step_close=false) {
    console.log('Show search wizard ')
    console.log(next_step_close)
    console.log(step+'')

    this.setState((prevState) => (
      {
          ...prevState,
          filters: {
              ...prevState.filters,
              'window': {
                  ...prevState.filters.windows,
                  'visible': true,
                  'active_tab': 'search',
                  'step': step,
                  'next_step_close': next_step_close
              }
          }            
      }
  ));
}

  async fetchDestinations() {

    console.log(`Fetch destinations`)
    const API_ENDPOINT = configData.API_ENDPOINT;
    const baseUrl = `${API_ENDPOINT}/search/destinations/`;
    const url = addLangParam(baseUrl);

    const results = await fetch(url)
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error(this.props.t('common.errors.network.error303'));
          }
        })

    this.setState(prevState=>(
      {
        ...prevState,
        'all_destinations': results
      }
    ))

}


  getFilters(filtersVal, updateURL=false) {

      //  If search window submit butto was clicked
      if (updateURL) { 
        
          filtersVal.QS = null;
          //console.log(filtersVal)
          const queryString = Object.keys(filtersVal).map(key => filtersVal[key]&&filtersVal[key]!=''&&key!='window'&&key!='origin'&&key!='rooms'?key + '=' + filtersVal[key]:null).filter(item=>item!=null).join('&');
          //console.log(queryString)

          if  (!filtersVal?.destinations || (filtersVal?.destinations && (filtersVal?.destinations.length==0 || filtersVal?.destinations==='' || filtersVal?.destinations.length > 1))) {
            window.location = '/?' + queryString        
            return;
          }

          // Incase we're in a specific 1 destination + month page dont change the url
          if (filtersVal?.destinations.length!==1) {

            if (this.props.match.path==="/:destination_name/:month" && (!filtersVal?.month || (filtersVal?.month && filtersVal?.month===''))) {
                window.location = `/${this.city}/?${queryString}`;
                return;
            }
          }

      }

      console.log('REFETCH...')
      // If incoming filters change date-related fields, clear selectedMonth so refetchData will pick a new default
      const shouldClearMonth = Object.prototype.hasOwnProperty.call(filtersVal, 'from_date') ||
                               Object.prototype.hasOwnProperty.call(filtersVal, 'to_date') ||
                               Object.prototype.hasOwnProperty.call(filtersVal, 'month') ||
                               Object.prototype.hasOwnProperty.call(filtersVal, 'months');

      this.setState(prevState=>({
          ...prevState,
          'isLoading': filtersVal.page>1?false:true,
          'filters': {
            ...prevState.filters,
            ...filtersVal
          },
          // reset selectedMonth/cheapestMonth when date filters changed so refetchData will recompute
          ...(shouldClearMonth ? { selectedMonth: null, cheapestMonth: null } : {})
      }),() => this.refetchData(true));
      
  }

  openSearch(event) {

    this.setState(prevState=> ({
      ...prevState,
      //'destinations': this.state.destinations,
      //'isLoading': false, 
      filters: {
        ...prevState.filters,
        'window': {
          ...prevState.filters.window,
          'visible': true,
          //'refresh_count': this.state.filters.window.refresh_count?this.state.filters.window.refresh_count++:0,
        },
       }
   }));
  }

  handleSelectMonth(event, year, month) {
    //event.preventDefault();
    //event.stopPropagation();

    console.log(`handleSelectMonth ${year} ${month}`)
    const selectedMonth = this.state?.monthsContent.find(item=>item.year == year && item.id == month-1);

    if (selectedMonth) {
      

        this.setState(prevState=>({
            ...prevState,
            'selectedMonth': {
                  year: selectedMonth.year,
                  month: selectedMonth.id+1
              }
        }));

        
        // Scroll to if not mobile
        scroller.scrollTo(
            window.innerWidth >= 768 ? `Y${selectedMonth.year}M${selectedMonth.id+1}`:`content`, 
            {
                duration: 200,
                delay: 0,
                smooth: true,
                //containerId: this.state.city,
                offset: -70, // Scrolls to element + 50 pixels up the page
            }
        );

        // set the focus on the element whose class name is 'content'
        if (document.getElementsByClassName('content') && document.getElementsByClassName('content').length >0 ) {
            console.log('Change Focus')
            document.getElementsByClassName('content')[0].focus();
        }

        // rerender
        this.forceUpdate();


    
    }


  }

  handleCloseSearchWindow() {

    this.setState((prevState)=>({
        ...prevState,
        filters: {
          ...prevState.filters,
          window: {
            ...prevState.filters.window,
            visible: false
          }
        }
      })
    )
  }

  /*

  handleClose() {
    //alert('closing')

    this.setState({
      //'destinations': this.state?.destinations, 
      'monthsContent': this.state.monthsContent,
      //'daysContent': this.state.daysContent,
      destinations: this.state.destinations,
      'isLoading': false, 
      filters: {...this.state.filters }
    })
  }*/
  
  handleFiltersClick = (event) => {
    window.dataLayer = window.dataLayer || [];
    const event_name = 'FiltersClick';
    console.log('GTM event: ' + event_name)
    window.dataLayer.push({
        page: 'destination',
        event: event_name,
        'pageUrl': window.location,
        'pageTitle' : window.title,
    });
  }

  handleToggleDestiantionTab = (event) => {
    const currentState = this.state;
    currentState.filters.window.visible = true;
    currentState.filters.window.active_tab = 'destination';
    this.setState(currentState);

    window.dataLayer = window.dataLayer || [];
    const event_name = 'DestinationChangeClicked';
    console.log('GTM event: ' + event_name)
    window.dataLayer.push({
        event: event_name,
        'pageUrl': window.location,
        'pageTitle' : window.title,
    });
    // refresh data
  }

  showDestinationSelectionPopup() {

    this.setState(prevState=>({
      ...prevState,
      'show_destinations_popup': true,
      'heading_key': ++prevState.heading_key
    }));
  }

  closeSearchWindow() {
    this.setState((prevState) => (
      {
          ...prevState,
          filters: {
              ...prevState.filters,  
              'window': {
                  ...prevState.filters.windows,
                  'visible': false,
              }
          }            
      }
  ));
  }

  gotoStep = (e, step, next_step_close=false) => {
    console.log('gotoStep', step)
    if (e) e.stopPropagation()

    // If we've click the step 1 button but it's empty jumpt to step 2
    if (step=='2') {
        if (this.state.filters?.dates_type==='exact'|| (this.state.filters?.holidays?.length>0 && !this.state.filters.holidays.find(holiday=>holiday.includes('school-summer-vacation'))) )
            step='3';
    }

    this.setState((prevState) => (
        {
           ...prevState,
            filters: {
                ...prevState.filters,  
                'window': {
                    ...prevState.filters.window,
                    'step': step+'',
                    'visible': true,//prevState.filters?.window?.visible?prevState.filters?.window?.visible:false,
                    'next_step_close': next_step_close
                    //'active_tab': 'search'
                }
            }            
        }
    ),()=>{
      console.log(this.state.filters)
    })
}


  render() {
    // Redirect to homepage if destination is invalid
    if (this.state.shouldRedirect) {
      return <Redirect to="/" />;
    }

    //this.gotoStep(null, 0, true);

    // conditional rendreing ahead
    /*const {error} = this.state;

    if (error) {
      return <p>{error.message}</p>;
    }*/

    //console.log(this.props.match.path) 
    // this.props.match.path == '/:destination_name'
    // this.props.match.path == '/:destination_name/:month'

    //console.log(this.state?.days)

    const { t } = this.props;
    const month_names = [
      t('common.months.january'), t('common.months.february'), t('common.months.march'),
      t('common.months.april'), t('common.months.may'), t('common.months.june'),
      t('common.months.july'), t('common.months.august'), t('common.months.september'),
      t('common.months.october'), t('common.months.november'), t('common.months.december')
    ];

    /*const city_id = this.state.filters.destination;
    const city_uid = this.state?.destinations[0]?.destination?.city_uid;
    const city_name = this.state?.destinations[0]?.destination?.city_name;
    const country_name = this.state?.destinations[0]?.destination?.country_name;*/
    const city_id = this.state.filters?.destination?.city_id;
    //const city_uid = this.state.filters?.destination?.sid;
    const city_name = this.state.filters?.destination?.city_name
    const country_name = this.state.filters?.destination?.country_name;
    const monthsContent = this.state.monthsContent.sort((a,b)=>(`${a.year}-${a.id < 10 ? '0' + a.id : a.id}`).localeCompare(`${b.year}-${b.id < 10 ? '0' + b.id : b.id}`));

    return (
        <>
        {
            !this.state.isLoading ? (
        
            <div className="App overlay"> 
                                
                {/*<div className="headerImagePlaceHolder"></div>      
                <h1 style={{fontWeight:'400', fontSize: '1.8em', padding: '0.5em', background: 'linear-gradient(90deg,#01bddd 3%,#124b71  45%)', color: '#fff'}}>חופשות ב{this.props.match.params.destination_name}</h1>*/}


                {/*<h1 style={{fontWeight:'800',  padding:0, color: '#0795b7', margin: '0.75em auto .5em'}}>חופשות ב{!this.state?.destinations[0]?.destination?.city_name?this.props.match.params.destination_name:this.state?.destinations[0]?.destination?.city_name}</h1>*/}
                <div className="destination">
                    <div className={"image " + this.state.filters?.destination?.sid}>    
                        <MainNavigationBar headerStyle={this.headerStyle} openSearchWindow={this.showSearchWindow} />

                            <div className="heading_wrapper">
                            <Heading key={'header'+this.state?.heading_key} show_popup={this.state?.show_destinations_popup} active='destination' destinations={this.state?.cities} destination={this.state?.filters?.destination} month={this.state?.filters?.month} destination_id={this.state?.filters?.destinations} destination_name={city_name} filters={this.state.filters} sendDataToCaller={this.getDestinationDetails} text={t('destination.heading.deals')} month_name={this.month_name} overview={
                                t('destination.overview.template', {
                                  city: city_name,
                                  monthYearPart: (this.month_name && this.year) ? `${t('destination.overview.monthPrefix')}${this.month_name} ` : '',
                                  pricePart: this.state?.cheapestPrice ? ` ${t('destination.meta.startingFromWithPrice', { price: this.state?.cheapestPrice })}` : '',
                                  monthPart: (this.month_name && this.year) ? `${t('destination.overview.monthPrefix')}${this.month_name}` : '',
                                  monthNamePart: (this.month_name && this.year) ? t('destination.overview.inMonth', { month: this.month_name }) : ''
                                })
                            }/>
                            </div>

                    </div>
                </div>
                
                <div className="content" name="content">
                    {this.props.match.path === '/:destination_name'?
                        (<MonthsDeck selectedMonth={this.state?.selectedMonth} cheapestMonth={this.state?.cheapestMonth} filters={this.state.filters} callback={this.handleSelectMonth} sendDataToCaller={this.getFilters} data={this.props.match.path === '/:destination_name'?monthsContent:this.state.destinations} ready={!this.state.isLoading} type='months' key="deck1" destination={this.state?.filters?.destination} meals={this.state?.filters?.meals} nights={this.state?.filters?.nights} stars={this.state?.filters?.stars} months={this.state?.filters?.months}  month={(this.month_name && this.month_name!=='')?this.month_name:undefined} page={this.state?.filters?.page} adults={this.state?.filters?.adults} teens={this.state?.filters?.teens} children={this.state?.filters?.children} infants={this.state?.filters?.infants}  dow={this.state?.filters?.dow} city={city_name} country={country_name} waterpark={this.state?.filters?.highlights?.waterpark} luxury={this.state?.filters?.highlights?.luxury} casino={this.state?.filters?.highlights?.casino} near_chabad={this.state?.filters?.highlights?.near_chabad} spa={this.state?.filters?.highlights?.spa} airlines={this.state?.filters?.airlines} t={this.props.t} />)
                        :(<></>)}

                    <FiltersManager 
                        t={this.props.t}
                        filters={this.state.filters} 
                        openSearch={this.state.filters?.window?.visible?this.state.filters?.window?.visible:false} 
                        destinations={this.state?.all_destinations} 
                        sendDataToCaller={this.getFilters} 
                        showSearchWindow={this.showSearchWindow} 
                        closeSearchWindow={this.closeSearchWindow}
                        gotoStep={this.gotoStep}
                        location={this.props.location} 
                        month_name={this.month_name} 
                        month={this.month} 
                        months={this?.months}
                        fetchDestinations={this.fetchDestinations}
                        year={this.year}></FiltersManager>
                
                    <div className={'preloader ' + (this.state.isLoading?' show-item':' hide-item')}>
                        <FontAwesomeIcon icon={faSpinner} spin size="3x" className="destination-preloader-spinner" />
                    </div>

                    <div  ref={this.myDivToFocus} className={'destination-deck-container deck-stars ' + (this.state.isLoading?' hidden':' ')}>
                        {
                        this.props.match.path === '/:destination_name' ? 
                            this.state.destinations && this.state.destinations[0] && this.state.destinations[0].deals && this.state.destinations[0]?.deals.length > 0 ? 
                                    monthsContent.map( (month,idx) =>{
                                                //if (month.year == this.selectedMonth.year && month.id+1 == this.selectedMonth.month)
                                                    return (<div key={`HorizontalDeck${idx}`} className={'destination-horizontal-deck-wrapper ' + (month.year == this.state?.selectedMonth?.year && month.id+1 == this.state?.selectedMonth?.month ? 'deck-horizontal': 'deck-horizontal hidden_mobile')}>
                                                        <HorizontalDeck 
                                                            t={this.props.t}
                                                            filters={this.state.filters} 
                                                            sendDataToCaller={this.getFilters} 
                                                            data={new Array(month)} 
                                                            ready={!this.state.isLoading} 
                                                            type='months' 
                                                            destination={this.state?.filters?.destination} 
                                                            meals={this.state?.filters?.meals} 
                                                            nights={this.state?.filters?.nights} 
                                                            stars={this.state?.filters?.stars} 
                                                            months={this.state?.filters?.months}  
                                                            month={(this.month_name && this.month_name!=='')?this.month_name:undefined} 
                                                            page={this.state?.filters?.page} 
                                                            adults={this.state?.filters?.adults} 
                                                            teens={this.state?.filters?.teens} 
                                                            children={this.state?.filters?.children} 
                                                            infants={this.state?.filters?.infants}  
                                                            dow={this.state?.filters?.dow} city={city_name} 
                                                            city_id={this.state?.filters?.destination?.city_id} 
                                                            country={country_name} 
                                                            waterpark={this.state?.filters?.highlights?.waterpark} 
                                                            luxury={this.state?.filters?.highlights?.luxury} 
                                                            casino={this.state?.filters?.highlights?.casino} 
                                                            near_chabad={this.state?.filters?.highlights?.near_chabad} 
                                                            spa={this.state?.filters?.highlights?.spa} 
                                                            airlines={this.state?.filters?.airlines} 
                                                            month_name={month_names[month.month]}
                                                            month_id={month.month_id}
                                                            hidden_mobile={(month.year == this.state?.selectedMonth?.year && month.id+1 == this.state?.selectedMonth?.month) ? false: true}
                                                            page_path = {this.props.match.path}
                                                        />
                                                        
                                                    </div>
                                                    )
                                        })
                                    /* 
                                    this.props.match.path == '/:destination_name'?
                                    (<MonthsDeck filters={this.state.filters} sendDataToCaller={this.getFilters} data={this.props.match.path === '/:destination_name'?this.state.monthsContent:this.state.destinations} ready={!this.state.isLoading} type='months' key="deck1" destination={this.state?.filters?.destination} meals={this.state?.filters?.meals} nights={this.state?.filters?.nights} stars={this.state?.filters?.stars} months={this.state?.filters?.months}  month={(this.month_name && this.month_name!=='')?this.month_name:undefined} page={this.state?.filters?.page} adults={this.state?.filters?.adults} teens={this.state?.filters?.teens} children={this.state?.filters?.children} infants={this.state?.filters?.infants}  dow={this.state?.filters?.dow} city={city_name} country={country_name} waterpark={this.state?.filters?.highlights?.waterpark} luxury={this.state?.filters?.highlights?.luxury} casino={this.state?.filters?.highlights?.casino} near_chabad={this.state?.filters?.highlights?.near_chabad} spa={this.state?.filters?.highlights?.spa} airlines={this.state?.filters?.airlines} />)
                                    :(<Deck filters={this.state.filters} sendDataToCaller={this.getFilters} data={this.props.match.path === '/:destination_name'?this.state.monthsContent:this.state.destinations} ready={!this.state.isLoading} type={'days'} key="deck1" destination={this.state?.filters?.destination} meals={this.state?.filters?.meals} nights={this.state?.filters?.nights} stars={this.state?.filters?.stars} months={this.state?.filters?.months}  month={(this.month_name && this.month_name!=='')?this.month_name:undefined} page={this.state?.filters?.page} adults={this.state?.filters?.adults} teens={this.state?.filters?.teens} children={this.state?.filters?.children} infants={this.state?.filters?.infants}  dow={this.state?.filters?.dow} city={city_name} country={country_name} waterpark={this.state?.filters?.highlights?.waterpark} luxury={this.state?.filters?.highlights?.luxury} casino={this.state?.filters?.highlights?.casino} near_chabad={this.state?.filters?.highlights?.near_chabad} spa={this.state?.filters?.highlights?.spa} airlines={this.state?.filters?.airlines} />)
                                    */
                                    /*<Deck filters={this.state.filters} sendDataToCaller={this.getFilters} data={this.props.match.path === '/:destination_name'?this.state.monthsContent:this.state.destinations} ready={!this.state.isLoading} type={'days'} key="deck1" destination={this.state?.filters?.destination} meals={this.state?.filters?.meals} nights={this.state?.filters?.nights} stars={this.state?.filters?.stars} months={this.state?.filters?.months}  month={(this.month_name && this.month_name!=='')?this.month_name:undefined} page={this.state?.filters?.page} adults={this.state?.filters?.adults} teens={this.state?.filters?.teens} children={this.state?.filters?.children} infants={this.state?.filters?.infants}  dow={this.state?.filters?.dow} city={city_name} country={country_name} waterpark={this.state?.filters?.highlights?.waterpark} luxury={this.state?.filters?.highlights?.luxury} casino={this.state?.filters?.highlights?.casino} near_chabad={this.state?.filters?.highlights?.near_chabad} spa={this.state?.filters?.highlights?.spa} airlines={this.state?.filters?.airlines} />*/
                            :
                                <div className="destination-no-results">
                                    <h3>
                                    {t('destination.messages.noResults')}</h3>
                                    <br />
                                    <h5>{t('destination.messages.changeFilters')}</h5>
                                </div>
                            
                        :(<></>)
                        }

                        {
                            
                            
                            this.props.match.path === '/:destination_name' ? (
                                <div className="destination-links-section">
                                    <ul className="destination-links-list">
                                        { monthsContent.map ( m=> {
                                                const monthName = this.props.t('common.months.' + (m.name.toLowerCase():''));  

                                                let more_deals_of_month_url = `/${city_name}/${monthName}/?destinations=${this.state?.filters?.destination?.city_id}&month=${m.year+'-'+(m.id+1)}`
                                                more_deals_of_month_url+= (this.state?.filters?.stars)?'&stars='+this.state?.filters?.stars:'';
                                                more_deals_of_month_url+= (this.state?.filters?.nights)?'&nights='+this.state?.filters?.nights:'';
                                                more_deals_of_month_url+= (this.state?.filters?.waterpark)?'&waterpark=1':'';
                                                more_deals_of_month_url+= (this.state?.filters?.luxury)?'&luxury=1':'';
                                                more_deals_of_month_url+= (this.state?.filters?.casino)?'&casino=1':'';
                                                more_deals_of_month_url+= (this.state?.filters?.near_chabad)?'&chabad=1':'';
                                                more_deals_of_month_url+= (this.state?.filters?.spa)?'&spa=1':'';
                                                more_deals_of_month_url+= (this.state?.filters?.meals)?'&meals='+this.state?.filters?.meals:'';
                                                more_deals_of_month_url+= (this.state?.filters?.adults)?'&adults='+this.state?.filters?.adults:'';
                                                more_deals_of_month_url+= (this.state?.filters?.teens)?'&teens='+this.state?.filters?.teens:'';
                                                more_deals_of_month_url+= (this.state?.filters?.children)?'&children='+this.state?.filters?.children:'';
                                                more_deals_of_month_url+= (this.state?.filters?.infants)?'&infants='+this.state?.filters?.infants:'';
                                                more_deals_of_month_url+= (this.state?.filters?.dow)?'&dow='+this.state?.filters?.dow:'';
                                                more_deals_of_month_url+= (this.state?.filters?.airlines)?'&airlines='+this.state?.filters?.airlines:'';
                                                return (<li key={`monthlink${m.month}`}>
                                                    <a className="destination-link" href={more_deals_of_month_url}>{t('destination.links.dealsToCity', { city: city_name, month: monthName })}</a></li>)
                                        })}
                                    </ul>
                                    <br />
                                </div>
                            ) : (<></>) 
                        }
                    </div>

                    {this.props.match.path !=  '/:destination_name/:month'?
                        (<></>)
                        :(<><Deck filters={this.state.filters} sendDataToCaller={this.getFilters} data={this.props.match.path === '/:destination_name'?this.state.monthsContent:this.state.destinations} ready={!this.state.isLoading} type='hotels' key="deck1" destination={this.state?.filters?.destination} meals={this.state?.filters?.meals} nights={this.state?.filters?.nights} stars={this.state?.filters?.stars} months={this.state?.filters?.months}  month={(this.month_name && this.month_name!=='')?this.month_name:undefined} page={this.state?.filters?.page} adults={this.state?.filters?.adults} teens={this.state?.filters?.teens} children={this.state?.filters?.children} infants={this.state?.filters?.infants}  dow={this.state?.filters?.dow} city={city_name} country={country_name} waterpark={this.state?.filters?.highlights?.waterpark} luxury={this.state?.filters?.highlights?.luxury} casino={this.state?.filters?.highlights?.casino} near_chabad={this.state?.filters?.highlights?.near_chabad} spa={this.state?.filters?.highlights?.spa} airlines={this.state?.filters?.airlines} /></>)}
                </div>
                
                <Footer hide={(this.state.isLoading?true:false)}/>
            </div>
            ) : (
                <div className="text-center mt-5 destination-loading-container">
                <Spinner alt={t('destination.spinner.alt')}
                    interval="2500"
                    images={['/images/destinations/krakow.jpg',
                            '/images/destinations/vienna.jpg',
                            '/images/destinations/antalya.jpg',
                            '/images/destinations/amsterdam.jpg']
                    }>
                    <h3 className="destination-loading-title">{t('destination.messages.loading')}   <span className="destination-loading-emoji">⌛</span></h3>
                    <p className="destination-loading-text">{t('destination.messages.loadingSubtext')}
                    </p>
                </Spinner>
                </div>
            )
        }
        </>
    )
  }
}

export default withTranslation()(Destination);
